import config from '../config';
import SoundManager from '../utils/SoundManager';
import {Howl, Howler} from '../utils/Howler';

const LOADER_BAR_WIDTH = 453;
const LOADER_BAR_HEIGHT = 20;

let soundManager;
let dataManager;

class Preload extends Phaser.Scene {
  init () {
    // console.log('Preload.init');
    let g = this;
    g.add.sprite(config.CENTER_X, config.CENTER_Y, 'loader-bg');

    let loaderBar = g.add.graphics();
    let loaderTape = g.add.sprite(config.CENTER_X - 225, config.CENTER_Y + 346, 'loader-tape');

    g.graphics = { loaderBar, loaderTape };

    dataManager = g.sys.game.dataManager;

    dataManager.setSessionItem(config.BASE_SCENE, 'Preload');
    
    this.assetLoadProgress = 0;
    this.audioLoadProgress = 0;
    this.audioLoadCount = 0;
    this.audioLoadTotal = 0;
    
    this.finished = false;

    g.load.on('progress', g.onLoadProgress, g);
  }

  onLoadProgress (progress) {
    this.assetLoadProgress = progress;
    this.updateLoadingBar();
  }
  
  updateLoadingBar(){
    let { loaderBar, loaderTape } = this.graphics;
    loaderBar.clear();
    loaderBar.fillStyle(0x8ebcea, 1);
    var progress = (this.assetLoadProgress * 0.75) + (this.audioLoadProgress * 0.25);
    loaderBar.fillRect(config.CENTER_X - 225, config.CENTER_Y + 335, LOADER_BAR_WIDTH * progress, LOADER_BAR_HEIGHT);
    loaderTape.setX(config.CENTER_X - 225 + LOADER_BAR_WIDTH * progress);
  }

  preload () {
    let g = this;

    var lang = this.cache.json.get('config').language;

    g.load.rexWebFont("fredburger_black_font", {
      "custom": {
          "families": ["FredBurger Black"],
          "urls": [config.MEDIA_FONT_PATH + (this.cache.json.get('config').language != "ar" ? "fredburger.css" : "fredburger_arabic.css")]
      }
  });
  
    g.LoadAudioFiles();

    g.load.path = config.MEDIA_LAYOUTS_PATH;

    /**
     * DAN START LEVEL LOAD HERE
     * ONLY LOAD ONE LEVEL AT A TIME
     */

    g.load.json('level-0', 'level-0.json');
    g.load.json('level-1', 'level-1.json');
    g.load.json('level-2', 'level-2.json');
    g.load.json('level-3', 'level-3.json');
    g.load.json('level-4', 'level-4.json');
    g.load.json('level-5', 'level-5.json');
    g.load.json('level-6', 'level-6.json');
    g.load.json('level-7', 'level-7.json');
    g.load.json('level-8', 'level-8.json');
    g.load.json('level-9', 'level-9.json');
    g.load.json('level-10', 'level-10.json');
    g.load.json('level-11', 'level-11.json');
    g.load.json('level-12', 'level-12.json');
    g.load.json('level-13', 'level-13.json');
    g.load.json('level-14', 'level-14.json');
    g.load.json('level-15', 'level-15.json');
    g.load.json('level-16', 'level-16.json');
    g.load.json('level-17', 'level-17.json');
    g.load.json('level-18', 'level-18.json');
    g.load.json('level-19', 'level-19.json');
    g.load.json('level-20', 'level-20.json');
    g.load.json('level-21', 'level-21.json');
    g.load.json('level-22', 'level-22.json');
    g.load.json('level-23', 'level-23.json');
    g.load.json('level-24', 'level-24.json');
    g.load.json('level-25', 'level-25.json');
    g.load.json('level-26', 'level-26.json');
    g.load.json('level-27', 'level-27.json');
    g.load.json('level-28', 'level-28.json');
    g.load.json('level-29', 'level-29.json');
    g.load.json('level-30', 'level-30.json');
    g.load.json('level-31', 'level-31.json');
    g.load.json('level-32', 'level-32.json');
    g.load.json('level-33', 'level-33.json');
    g.load.json('level-34', 'level-34.json');
    g.load.json('level-35', 'level-35.json');
    g.load.json('level-36', 'level-36.json');
    g.load.json('level-37', 'level-37.json');
    g.load.json('level-38', 'level-38.json');
    g.load.json('level-39', 'level-39.json');

    /**
     * DAN END LEVEL LOAD HERE
     */

    g.load.path = config.MEDIA_IMAGE_PATH;

    // common
    g.load.image('overlay', 'common/overlay.png');
    g.load.atlas('common', 'common/sprite.png', 'common/sprite.json');
    g.load.atlas('common-tape', 'tape.png', 'tape.json');
    g.load.image('packing', 'packing.png');

    // settings
    g.load.image('settings-box', 'settings/box-wo-bears.png');
    g.load.image('settings-flash', 'settings/flash.png');
    g.load.atlas('settings-arm', 'settings/arm.png', 'settings/arm.json');
    g.load.multiatlas('settings-bears', 'settings-bears.json');

    // intro scene
    g.load.image('intro-bg', 'intro/bg-wo-bears.png');
    // g.load.image('intro-tape', 'intro/tape.png');
    g.load.atlas('intro-ice', 'intro/ice.png', 'intro/ice.json');
    g.load.atlas('intro-grizz', 'intro/grizz.png', 'intro/grizz.json');
    g.load.atlas('intro-panda', 'intro/panda.png', 'intro/panda.json');
    g.load.atlas('intro-packing', 'intro/packing.png', 'intro/packing.json');
    g.load.atlas('intro-tape', 'intro/tape.png', 'intro/tape.json');

    // play scene
    g.load.atlas('tiles-closed', 'tiles-closed.png', 'tiles-closed.json');
    g.load.atlas('tiles-open', 'tiles-open.png', 'tiles-open.json');
    g.load.atlas('tiles-inactive', 'tiles-inactive.png', 'tiles-inactive.json');
    g.load.atlas('bracket', 'brackets.png', 'brackets.json');
    g.load.atlas('play-sprite', 'play/sprite.png', 'play/sprite.json');
    g.load.image('play-bg', 'play/bg.jpg');
    g.load.atlas('play-poof', 'play/poof.png', 'play/poof.json');
    g.load.atlas('play-bears', 'play/bears.png', 'play/bears.json');
    g.load.atlas('collectables', 'play/collectables.png', 'play/collectables.json');

    // score scene
    g.load.image('score-bg', 'score/bg-wo-bears.jpg');
    // g.load.atlas('score-tape', 'score/tape.png', 'score/tape.json');
    g.load.atlas('score-poof', 'score/poof.png', 'score/poof.json');
    g.load.multiatlas('score-bears', 'score-bears.json');
    g.load.multiatlas('end-tape', 'end-tape.json');

    // misc
    g.load.image('btn', 'btn.png');

    var lang = this.cache.json.get('config').language;
    //logo
    g.load.image('brandLogo', 'intro/brandlogo.png');
    g.load.image('cnLogo', 'intro/cn_logo.png');
    g.load.image('logo', 'intro/logo_' + lang + '.png');
  }
  create () {
    // console.log('Preload.create');
    let g = this;

    let frames;
    frames = g.anims.generateFrameNames('common-tape', {
      prefix: 'no-moves-tape_',
      start: 0,
      end: 23,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'common-tape-animate',
      frames: frames
    });
    frames = g.anims.generateFrameNames('intro-tape', {
      prefix: 'intro-tape_',
      start: 0,
      end: 16,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'intro-tape-animate',
      frames: frames
    });
    frames = g.anims.generateFrameNames('intro-ice', {
      prefix: 'ice_',
      start: 25,
      end: 38,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'intro-ice-animate',
      frames: frames
    });
    frames = g.anims.generateFrameNames('intro-grizz', {
      prefix: 'grizz_',
      start: 0,
      end: 13,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'intro-grizz-animate',
      frames: frames
    });
    frames = g.anims.generateFrameNames('intro-panda', {
      prefix: 'panda_',
      start: 11,
      end: 24,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'intro-panda-animate',
      frames: frames
    });
    frames = g.anims.generateFrameNames('intro-packing', {
      prefix: 'intro-packing_',
      start: 13,
      end: 37,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'intro-packing-animate',
      frames: frames,
      showOnStart: true
    });

    frames = g.anims.generateFrameNames('bracket', {
      prefix: 'brackets_',
      start: 0,
      end: 7,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'bracket-select',
      frames: frames
    });
    g.anims.create({
      key: 'bracket-selected',
      frames: [{ key: 'bracket', frame: 'brackets_07.png' }]
    });
    g.anims.create({
      key: 'bracket-hidden',
      frames: [{ key: 'bracket', frame: 'brackets_00.png' }]
    });
    g.anims.create({
      key: 'bracket-match',
      frames: [{ key: 'bracket', frame: 'brackets_match.png' }]
    });
    g.anims.create({
      key: 'bracket-no-match',
      frames: [{ key: 'bracket', frame: 'brackets_no_match.png' }]
    });
    frames = g.anims.generateFrameNames('play-poof', {
      prefix: 'end-game-poof_',
      start: 2,
      end: 35,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'play-poof-animate',
      frames: frames,
      showOnStart: true,
      hideOnComplete: true
    });
    frames = g.anims.generateFrameNames('settings-bears', {
      prefix: 'pop-up-bears_',
      start: 0,
      end: 40,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'settings-bears-loop',
      frames: frames,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('settings-arm', {
      prefix: 'panda-arm_',
      start: 26,
      end: 190,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'settings-arm-loop',
      frames: frames,
      repeat: -1,
      repeatDelay: 3000
    });
    // frames = g.anims.generateFrameNames('score-tape', {
    //   prefix: 'end-game-tape_',
    //   start: 0,
    //   end: 23,
    //   suffix: '.png',
    //   zeroPad: 2
    // });
    // g.anims.create({
    //   key: 'score-tape-animate',
    //   frames: frames
    // });
    frames = g.anims.generateFrameNames('end-tape', {
      prefix: 'end-game-tape_',
      start: 0,
      end: 23,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'end-tape-animate',
      frames: frames
    });
    frames = g.anims.generateFrameNames('score-poof', {
      prefix: 'end-game-poof_',
      start: 2,
      end: 35,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'score-poof-animate',
      frames: frames,
      showOnStart: true,
      hideOnComplete: true
    });
    frames = g.anims.generateFrameNames('score-bears', {
      prefix: 'end-game-bears_',
      start: 0,
      end: 18,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'score-bears-animate',
      frames: frames
    });
    g.scene.launch('SoundManager');

    dataManager.setSessionItem('continueAvailable', true);

    if (g.sys.game.globalPauseActive) {
      g.queuedLaunch = true;
    } else {
      g.scene.start('Intro');
      // g.scene.start('Play', { fixedHighScore: false, replayLevel: false, isNewGame: false });
      // g.scene.start('Score');
    }
  }
  update () {
    let g = this;
    if (g.queuedLaunch) {
      if (!g.sys.game.globalPauseActive) {
        g.scene.start('Intro');
      }
    }
  }
  
  LoadAudioFiles(){
    var g = this;
    g.load.path = config.MEDIA_AUDIO_PATH;
    // loops
    this.LoadAudio('loop-continue', 'loops/continue.mp3');
    this.LoadAudio('loop-end', 'loops/end-game.mp3');
    this.LoadAudio('loop-intro', 'loops/intro.mp3');
    this.LoadAudio('loop-main', 'loops/loop-main.mp3');
    // sfx
    this.LoadAudio('bomb', 'sfx/bomb/bomb.mp3');
    this.LoadAudio('box-open', 'sfx/box-open/box-open.mp3');
    this.LoadAudio('button-press', 'sfx/button-press/button-press.mp3');
    this.LoadAudio('found-bear', 'sfx/found-bear/found-bear.mp3');
    this.LoadAudio('found-object', 'sfx/found-object/found-object.mp3');
    this.LoadAudio('hint', 'sfx/hint/hint.mp3');
    this.LoadAudio('match', 'sfx/match/match.mp3');
    this.LoadAudio('no-match', 'sfx/no-match/no-match.mp3');
    this.LoadAudio('play-button', 'sfx/play-button/grizz-get-ready.mp3');
    this.LoadAudio('tape', 'sfx/tape/tape-short.mp3');
    this.LoadAudio('undo', 'sfx/undo/undo.mp3');
    this.LoadAudio('vo-found-grizz', 'sfx/vo-found-grizz/grizz-laugh.mp3');
    // sfx array
    this.LoadAudio('array-vo-found-object-1', 'sfx/vo-found-object/objectfound-ahhh.mp3');
    this.LoadAudio('array-vo-found-object-2', 'sfx/vo-found-object/objectfound-haha.mp3');
    this.LoadAudio('array-vo-found-object-3', 'sfx/vo-found-object/objectfound-OOH.mp3');
    this.LoadAudio('array-vo-found-object-4', 'sfx/vo-found-object/objectfound-waaah.mp3');
    this.LoadAudio('array-vo-game-start-1', 'sfx/vo-game-start/bears-waahhhoo.mp3');
  }
  
  LoadAudio(key, url){    
    if(!SoundManager.cache[key]){
      url = this.load.path + url;
      this.audioLoadTotal++;
            
      SoundManager.cache[key] = { src: url };
      
      var howl = new Howl({
          src: url
      });
      howl.once('load', this.OnLoadedAudio.bind(this));
    }
  }
  
  OnLoadedAudio(){
    this.audioLoadCount++;
    this.audioLoadProgress = this.audioLoadCount / this.audioLoadTotal;
  }
}

export default Preload;
